import { createPopper } from '@popperjs/core';

// Dışarıya tıklanınca tüm menüleri kapat
document.getElementsByTagName("body")[0].addEventListener('click', () => {
  document.querySelectorAll('.popper-menu-target').forEach((element)=>{
    element.classList.add('invisible');
  })
});

// Tüm popper-menu elementlerini bul
document.querySelectorAll('.popper-menu').forEach( (menuElement) => {
    
  const target = menuElement.getAttribute('data-menu');
  const targetElement = document.querySelector('#' + target);

  // Hedef elementi menü haline getir
  const popper = createPopper(menuElement, targetElement, {
    placement: 'bottom-end',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10]
        }
      }
    ]
  })

  // Hedef menüyü aç kapat
  menuElement.addEventListener('click', (event) => {
    event.stopPropagation();
    targetElement.classList.toggle('invisible');
  })

})